import { EntityConfig } from 'angular-odata';

//#region ODataApi Imports
import { ProduktTypGroup } from './produkttypgroup.entity';
//#endregion

export const ProduktTypGroupConfig = {
  name: "ProduktTypGroup",
  annotations: [],
  fields: {
    produktTypId: {type: 'Edm.Int32'},
    groupId: {type: 'Edm.Int32'},
    sortValue: {type: 'Edm.Int32'},
    statusId: {type: 'Edm.Int32'},
    statusTypeId: {type: 'Edm.Int32'},
    statusAt: {type: 'Edm.DateTimeOffset'},
    statusBy: {type: 'Edm.String'},
    createdBy: {type: 'Edm.String'},
    id: {type: 'Edm.Int32', key: true, ref: 'id', nullable: false},
    produktTyp: {type: 'entities.produkte.ProduktTyp', navigation: true, field: 'produktTypId', ref: 'id'},
    group: {type: 'entities.schema.Group', navigation: true, field: 'groupId', ref: 'id'},
    status: {type: 'entities.settings.Status', navigation: true, field: 'statusId', ref: 'id'},
    statusType: {type: 'entities.settings.StatusType', navigation: true, field: 'statusTypeId', ref: 'id'}
  }
} as EntityConfig<ProduktTypGroup>;